export const DealRoom = () => {
    return (
        <div className="p-8">
            <div className="text-2xl font-bold mb-8">Deal Room</div>
            <div className="grid">
                Coming soon
            </div>
        </div>
    )
}